/* eslint-disable import/order */
// Vendors
import Vue from 'vue';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router';
import * as Sentry from '@sentry/vue';
import { Integrations as TracingIntegrations } from '@sentry/tracing';
import { CaptureConsole as CaptureConsoleIntegration } from '@sentry/integrations';

import store from './store';

// Components
import App from './App.vue';
import icons from '@/components/common/icons';
import SIcon from '@/components/common/SIcon.vue';
import appAtomsMap from '@/components/atoms/index';
import Loader from '@/components/common/Loader.vue';
import AppLoader from '@/components/common/AppLoader.vue';
import AppAvatarGroup from '@/components/common/AppAvatarGroup.vue';
import LoaderWrapper from '@/components/common/LoaderWrapper.vue';
import AppAvatar from '@/components/common/AppAvatar/AppAvatar.vue';
import AppGroupAvatar from '@/components/common/AppGroupAvatar.vue';
import AppTabs from '@/components/common/AppTabs.vue';
import AppTabSelector from '@/components/common/AppTabSelector.vue';
import AppTooltip from '@/components/common/AppTooltip.vue';
import Row from '@/components/common/Row.vue';
import AppPagination from '@/components/common/AppPagination.vue';
import Col from '@/components/common/Col.vue';
import InfoSection from '@/components/common/InfoSection.vue';
import IntegrationIcon from '@/components/common/icons/IntegrationIcon/IntegrationIcon.vue';
// Logic / others
import FeatureToggleService from '@/utils/feature-toggle-service';
import { getAllFeatureFlags } from '@/store/modules/featureFlags/actions';
import AnalyticsService from '@/utils/AnalyticsService';
import './styles/global.scss';
import { Modes } from './common.js';
import { StripePlugin } from '@vue-stripe/vue-stripe';

const COMMON_GLOBAL_COMPONENTS = {
	...icons,
	SIcon,
	Loader,
	AppLoader,
	AppAvatarGroup,
	LoaderWrapper,
	AppAvatar,
	AppGroupAvatar,
	AppTabs,
	AppTabSelector,
	AppTooltip,
	InfoSection,
	IntegrationIcon,
	Row,
	Col,
	AppPagination,
};
const SENTRY_DSN = 'https://04d31340993947898ebb12eccbd7d178@o576278.ingest.sentry.io/5729735';

//@ts-ignore
export function runEntrypoint({ router, globalComponents = {} }) {
	console.timeEnd('since index.html');
	console.time('entrypoint->mounted');

	//@ts-ignore
	if (parseInt(process.env.VUE_APP_ENABLE_SENTRY)) {
		Sentry.init({
			Vue,
			dsn: SENTRY_DSN,
			integrations: [
				new TracingIntegrations.BrowserTracing({
					routingInstrumentation: Sentry.vueRouterInstrumentation(router),
				}),
				new CaptureConsoleIntegration({ levels: ['error'] }),
			],
			environment: process.env.VUE_APP_PLY_ENV,
			// Set tracesSampleRate to 1.0 to capture 100%
			// of transactions for performance monitoring.
			// We recommend adjusting this value in production
			tracesSampleRate: process.env.VUE_APP_PLY_ENV === Modes.Production ? 0.1 : 0,
			normalizeDepth: 3, // level that Objects are destructured in the logs (instead of seeing [object Object])
		});
	}
	if (Modes.Production === process.env.VUE_APP_PLY_ENV) {
		AnalyticsService.initAnalytics();
	}
	//@ts-ignore
	FeatureToggleService.setOnInit(() => store.dispatch(getAllFeatureFlags.fullPath));

	const componentsToLoad = { ...COMMON_GLOBAL_COMPONENTS, ...appAtomsMap, ...globalComponents };
	//@ts-ignore
	Object.entries(componentsToLoad).forEach(([name, component]) => Vue.component(name, component));

	Vue.config.productionTip = false;

	Vue.use(VueRouter);

	const stripeConfiguration = {
		pk: `${process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY}`,
		stripeAccount: `${process.env.VUE_APP_STRIPE_ACCOUNT}`,
		testMode: process.env.VUE_APP_PLY_ENV !== Modes.Production,
	};
	Vue.use(StripePlugin, stripeConfiguration);

	new Vue({
		//@ts-ignore
		store,
		router,
		//@ts-ignore
		vuetify,
		//@ts-ignore
		render: (h) => h(App),
	}).$mount('#app');
}

export function runExternalEndpointComplementaryInitialization() {
	const ftsUser = FeatureToggleService.buildFtsAnonObject(); // Anonymous user
	FeatureToggleService.initializeUser(ftsUser);
}
